import './ProjectListHeader.scss';
import clsx from 'clsx';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as format from 'src/modules/common/constants/formattingHelpers';
import { ProjectListColumn, ProjectListColumnKey } from 'src/modules/project-list/types/ProjectListColumn';
import { ProjectListQuery } from 'src/modules/project-list/types/ProjectListQuery';
import { ProjectListSortLink } from 'src/modules/project-list/views/ProjectListSortLink';
import { assertNever } from 'src/utils/assert';

type Props = {
  readonly query: ProjectListQuery;
  readonly columns: ReadonlyArray<ProjectListColumn>;
  readonly scrollable: boolean;
};

export const ProjectListHeader = ({ query, columns, scrollable }: Props): React.ReactElement => (
  <div className="bp-project-list-header">
    <div className="bp-project-list-header__column bp-project-list-header__column--image"/>

    <ProjectListSortLink
      query={query}
      field="title"
      className={clsx({
        'bp-project-list-header__column--title': true,
        'bp-project-list-header__column--title-overflow': scrollable,
      })}
    >
      <FormattedMessage id="projectList/projectListHeader/project"/>
    </ProjectListSortLink>

    {columns.filter((column) => column.enabled).map((column) => {
      if (column.key === ProjectListColumnKey.MEMBERS) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="members">
            <FormattedMessage id="projectList/projectListHeader/members"/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.STATUS) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="status">
            <FormattedMessage id="projectList/projectListHeader/status"/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.UPDATED) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="updated">
            <FormattedMessage id="projectList/projectListHeader/lastUpdated"/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.ROI) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="roi">
            <FormattedMessage id="projectList/projectListHeader/ROI_excl_CO2_10" values={format}/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.ROI_2) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="roi_2">
            <FormattedMessage id="projectList/projectListHeader/ROI_excl_CO2_2" values={format}/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.ROI_5) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="roi_5">
            <FormattedMessage id="projectList/projectListHeader/ROI_excl_CO2_5" values={format}/>
          </ProjectListSortLink>
        );
      }
      if (column.key === ProjectListColumnKey.BEP) {
        return (
          <ProjectListSortLink key={column.key} query={query} field="bep">
            <FormattedMessage id="projectList/projectListHeader/BEP_excl_CO2" values={format}/>
          </ProjectListSortLink>
        );
      }

      return assertNever('Invalid column', { column });
    })}

    <ProjectListSortLink
      query={query}
      field="rating"
      className={clsx({
        'bp-project-list-header__column--rating': true,
        'bp-project-list-header__column--rating-overflow': scrollable,
      })}
    >
      <FormattedMessage id="projectList/projectListHeader/energyEfficiency"/>
    </ProjectListSortLink>

    <div className="bp-project-list-header__column bp-project-list-header__column--menu"/>
  </div>
);
